<template>
    <div>
        <div v-if="isLoading" class="intelligence-state">
            <common-logo-spinner :width="56"></common-logo-spinner>
            <span>{{ $t('pages.intelligence.delivery.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.delivery.error') }}
        </div>

        <template v-else-if="delivery">
            <intelligence-delivery-kpi-cards :kpis="delivery.kpis"></intelligence-delivery-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-delivery-chart :channels="delivery.channels"></intelligence-delivery-chart>
                <intelligence-delivery-table :channels="delivery.channels"></intelligence-delivery-table>
            </div>
        </template>
    </div>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceDeliveryKpiCards from 'components/page-elements/intelligence/IntelligenceDeliveryKpiCards'
    import IntelligenceDeliveryChart from 'components/page-elements/intelligence/IntelligenceDeliveryChart'
    import IntelligenceDeliveryTable from 'components/page-elements/intelligence/IntelligenceDeliveryTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceDeliveryKpiCards,
            IntelligenceDeliveryChart,
            IntelligenceDeliveryTable,
        },

        props: {
            filters: { type: Object, default: null },
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                delivery: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.delivery.title')
            },
        },

        methods: {
            loadDelivery() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getDelivery(this.filters)
                    .then((response) => {
                        this.delivery = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.delivery = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        watch: {
            filters: {
                immediate: true,
                handler() {
                    this.loadDelivery()
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
